import {AdminBaseUrl, AdminGenRouteUrls, AdminModuleRouteUrls, AdminModules} from "./config/AdminConfig";
import {getDefStr, isBoolTrue} from "../common/fusion-ui/utils/ReactUtils";
import {
    _404Page,
    ArticlePage,
    BackupDbPage,
    City__AddEditFormPage,
    CityPage,
    Company__AddEditFormPage,
    CompanyPage,
    Country__AddEditFormPage,
    CountryPage,
    CsPage,
    DashboardPage,
    DbMaintenancePage,
    DocPage,
    ExpSpeaks__AddEditFormPage,
    ExpSpeaksPage,
    ForgotPwPage,
    ForumPage,
    Group__AddEditFormPage,
    Group__AddEditMembersFormPage,
    GroupsPage,
    ImagePage,
    LinkPage,
    LoginBypassManager__EditFormPage,
    LoginBypassManagerPage,
    LoginPage,
    MeetingPage,
    Member__AddEditFormPage,
    MembersPage,
    ModuleAllocationPage,
    NewsPage,
    ParentCompany__AddEditFormPage,
    ParentCompanyPage,
    PubPage,
    QueryWindowPage,
    ReportsPage,
    State__AddEditFormPage,
    StatePage,
    SurveyPage,
    User__AddEditFormPage,
    UserRole__AddEditFormPage,
    UserRolesPage,
    UsersPage,
    VideoPage,
    WmPage,
} from "./components";
import {useAdminAuth} from "./context/AdminAuthProvider";

//Lazy Imports

const TAG = 'adminRoutes.js';

export default function getAdminRoutes(isCurrUrlOfAuthRoute = false) {
    const {isAuthenticated} = useAdminAuth();
    // const {isAuthenticated} = {isAuthenticated: false};//for testing only
    // console.log(TAG, 'getAdminRoutes.isAuthenticated:', isAuthenticated);
    // return getPublicRoutes();//for testing only
    return isAuthenticated ? getPrivateRoutes() : getPublicRoutes();

    function getPublicRoutes() {
        return [
            createRoute(AdminModules.Login, <LoginPage/>, AdminGenRouteUrls.login),
            createRoute(AdminModules.ForgotPw, <ForgotPwPage/>, AdminGenRouteUrls.forgotPw),
            createRoute(AdminModules.Login, <LoginPage/>, AdminModuleRouteUrls[AdminModules.Dashboard]),
            createRoute(AdminModules.Login, <LoginPage/>, AdminBaseUrl),
            createRoute(AdminModules.Login, <LoginPage/>, AdminGenRouteUrls._404),
            // ...getPrivateRoutes(),//for testing only
        ]
    }

    function getPrivateRoutes() {
        return [
            //Pages
            createRoute(AdminModules.Dashboard, <DashboardPage/>, AdminBaseUrl),
            createRoute(AdminModules.Dashboard, <DashboardPage/>),
            createRoute(AdminModules.ParentCompany, <ParentCompanyPage/>),
            createRoute(AdminModules.Company, <CompanyPage/>),
            createRoute(AdminModules.Members, <MembersPage/>),
            createRoute(AdminModules.Groups, <GroupsPage/>),
            createRoute(AdminModules.Country, <CountryPage/>),
            createRoute(AdminModules.State, <StatePage/>),
            createRoute(AdminModules.City, <CityPage/>),
            createRoute(AdminModules.ModuleAllocation, <ModuleAllocationPage/>),
            createRoute(AdminModules.LoginBypassManager, <LoginBypassManagerPage/>),
            createRoute(AdminModules.Wm, <WmPage/>),
            createRoute(AdminModules.Forum, <ForumPage/>),
            createRoute(AdminModules.Survey, <SurveyPage/>),
            createRoute(AdminModules.Meeting, <MeetingPage/>),
            createRoute(AdminModules.Pub, <PubPage/>),
            createRoute(AdminModules.Doc, <DocPage/>),
            createRoute(AdminModules.Articles, <ArticlePage/>),
            createRoute(AdminModules.CS, <CsPage/>),
            createRoute(AdminModules.Videos, <VideoPage/>),
            createRoute(AdminModules.Images, <ImagePage/>),
            createRoute(AdminModules.Links, <LinkPage/>),
            createRoute(AdminModules.ExpertSpeaks, <ExpSpeaksPage/>),
            createRoute(AdminModules.News, <NewsPage/>),
            createRoute(AdminModules.BackupDb, <BackupDbPage/>),
            createRoute(AdminModules.DbMaintenance, <DbMaintenancePage/>),
            createRoute(AdminModules.QueryWindow, <QueryWindowPage/>),
            createRoute(AdminModules.Users, <UsersPage/>),
            createRoute(AdminModules.UserRoles, <UserRolesPage/>),
            createRoute(AdminModules.Reports, <ReportsPage/>),

            //Form pages
            createInternalPageRoute(AdminModules.ParentCompany, <ParentCompany__AddEditFormPage/>, AdminGenRouteUrls.parentCompany_addPage),
            createInternalPageRoute(AdminModules.ParentCompany, <ParentCompany__AddEditFormPage updateOnly={true}/>, AdminGenRouteUrls.parentCompany_editPage),

            createInternalPageRoute(AdminModules.Company, <Company__AddEditFormPage/>, AdminGenRouteUrls.company_addPage),
            createInternalPageRoute(AdminModules.Company, <Company__AddEditFormPage updateOnly={true}/>, AdminGenRouteUrls.company_editPage),

            createInternalPageRoute(AdminModules.Members, <Member__AddEditFormPage/>, AdminGenRouteUrls.member_addPage),
            createInternalPageRoute(AdminModules.Members, <Member__AddEditFormPage updateOnly={true}/>, AdminGenRouteUrls.member_editPage),
            createInternalPageRoute(AdminModules.Members, <Member__AddEditFormPage cloneMode={true}/>, AdminGenRouteUrls.member_clonePage),

            createInternalPageRoute(AdminModules.Groups, <Group__AddEditFormPage/>, AdminGenRouteUrls.groups_addPage),
            createInternalPageRoute(AdminModules.Groups, <Group__AddEditFormPage updateOnly={true}/>, AdminGenRouteUrls.groups_editPage),
            createInternalPageRoute(AdminModules.Groups, <Group__AddEditMembersFormPage updateOnly={true}/>, AdminGenRouteUrls.groups_editGroupMembersPage),

            createInternalPageRoute(AdminModules.Country, <Country__AddEditFormPage/>, AdminGenRouteUrls.country_addPage),
            createInternalPageRoute(AdminModules.Country, <Country__AddEditFormPage updateOnly={true}/>, AdminGenRouteUrls.country_editPage),

            createInternalPageRoute(AdminModules.State, <State__AddEditFormPage/>, AdminGenRouteUrls.state_addPage),
            createInternalPageRoute(AdminModules.State, <State__AddEditFormPage updateOnly={true}/>, AdminGenRouteUrls.state_editPage),

            createInternalPageRoute(AdminModules.City, <City__AddEditFormPage/>, AdminGenRouteUrls.city_addPage),
            createInternalPageRoute(AdminModules.City, <City__AddEditFormPage updateOnly={true}/>, AdminGenRouteUrls.city_editPage),

            createInternalPageRoute(AdminModules.LoginBypassManager, <LoginBypassManager__EditFormPage
                updateOnly={true}/>, AdminGenRouteUrls.login_bypass_mngr_editPage),

            createInternalPageRoute(AdminModules.UserRoles, <UserRole__AddEditFormPage/>, AdminGenRouteUrls.userRoles_addPage),
            createInternalPageRoute(AdminModules.UserRoles, <UserRole__AddEditFormPage updateOnly={true}/>, AdminGenRouteUrls.userRoles_editPage),

            createInternalPageRoute(AdminModules.Users, <User__AddEditFormPage/>, AdminGenRouteUrls.users_addPage),
            // createInternalPageRoute(AdminModules.Users, <User__AddEditFormPage updateOnly={true}/>, AdminGenRouteUrls.users_editPage),

            createInternalPageRoute(AdminModules.ExpertSpeaks, <ExpSpeaks__AddEditFormPage/>, AdminGenRouteUrls.expertSpeaks_addPage),
            createInternalPageRoute(AdminModules.ExpertSpeaks, <ExpSpeaks__AddEditFormPage updateOnly={true}/>, AdminGenRouteUrls.expertSpeaks_editPage),

            //Include 404 route as default-route
            !isBoolTrue(isCurrUrlOfAuthRoute) && {route: AdminGenRouteUrls._404, component: <_404Page/>},
        ]
    }
}

function createRoute(name, component, routeUrl = null) {
    return {
        name: name,
        route: getDefStr(routeUrl, AdminModuleRouteUrls[name]),
        component: component,
    }
}

function createInternalPageRoute(name, component, routeUrl) {
    return {
        name: name,
        // route: (routeUrl + '').replace('?id=', ''),
        route: (routeUrl + '').replace('?id=', '').replace('?sid=', ''),
        component: component,
    }
}
